import { Injectable } from '@angular/core';

interface BuddySettings {
  name: string;
  iconUrl: string;
  endpoint: string;
  useAuth?: boolean;
}

@Injectable({ providedIn: 'root' })
export class BuddyConfigService {
  buddyConfig: BuddySettings;
  private activeConfigKey: string;

  selectConfig(id: string): BuddySettings {
    let config = this.buddyConfigs[id];

    if (!config) {
      config = this.buddyConfigs['none'];
    }
    if (config.iconUrl == '') {
      config.iconUrl = 'assets/imgs/buddy.svg';
    }
    this.buddyConfig = config;
    this.activeConfigKey = id in this.buddyConfigs ? id : 'none';

    return config;
  }

  getActiveConfigKey(): string {
    return this.activeConfigKey;
  }

  private buddyConfigs: Record<string, BuddySettings> = {
    none: {
      name: 'Buddy',
      iconUrl: 'assets/imgs/buddy.svg',
      endpoint: 'https://chat.dwin.health',
    },
    '62a01583-850d-48df-b9e3-f1480a440545': {
      name: 'Buddy (Redaktion)',
      iconUrl:
        'https://cdn.prod.website-files.com/654e360728e01c51acb50896/6557611f61af1c7b31d560ba_Group%20685.webp',
      endpoint: 'https://chat.dwin.health/dev-dd',
    },
    '4bb3d974-8ab6-41d6-9f9a-e66a057e80a1': {
      name: 'Buddy (auto)',
      iconUrl:
        'https://cdn.prod.website-files.com/654e360728e01c51acb50896/6557611f61af1c7b31d560ba_Group%20685.webp',
      endpoint: 'https://chat.dwin.health/dev-dd-autochunk',
    },
    'e7bf59f3-5f72-4b82-9f5f-f0b823ed51e9': {
      name: 'Notfallbuddy',
      iconUrl: '',
      endpoint: 'https://chat.dwin.health/notfallguru',
    },
    'f3e25370-f21d-48da-8657-8eae7ce97d32': {
      name: 'Buddy',
      iconUrl:
        'https://msbewegt.ztm.de/templates/yootheme/cache/c7/ms_logo_1024_500-c72555f5.webp',
      endpoint: 'https://chat.dwin.health/dev-ztm',
    },
    '0e39a65c-305e-48a1-bbb5-c03d73c56d23': {
      name: 'Buddy',
      iconUrl: 'https://www.ztm.de/images/logos/ZTMLogos/ZTM_Logo_iOS_Icon.png',
      endpoint: 'https://chat.dwin.health/ztm-website',
    },
    'c360ad60-eb70-4b4a-9993-109336016283': {
      name: 'Buddy',
      iconUrl:
        'https://www.ztm.de/templates/yootheme/cache/03/Curafida%20Logo_RGB-03c948fe.webp',
      endpoint: 'https://chat.dwin.health/curafida-info',
    },
    plain: {
      name: 'Buddy Plain',
      iconUrl: '',
      endpoint: 'https://chat.dwin.health/plain',
    },
    '3c323ad3-ff15-42e3-9e52-deea8e7ef822': {
      name: 'Buddy',
      iconUrl:
        'https://www.dico-pflege.de/templates/yootheme/cache/16/DiCo_Logo-169dc69c.webp',
      endpoint: 'https://chat.dwin.health/dico',
    },
    '7a243da6-3fd2-4987-b2d3-5329cc9dc37a': {
      name: 'Pflegebuddy',
      iconUrl: '',
      endpoint: 'https://chat.dwin.health/pflege',
    },
    'ce0feb90-d9ad-45d5-83c1-5c30d6cf4b25': {
      name: 'MS Buddy',
      iconUrl: 'https://i.imgur.com/9VarzvC.png',
      endpoint: 'https://chat.dwin.health/ms-de',
    },
    '45ece855-46ef-4424-90ea-0fac218827d3': {
      name: 'MS Buddy',
      iconUrl: 'https://i.imgur.com/BVm7P3h.png',
      endpoint: 'https://chat.dwin.health/ms-en',
    },
    '80001e36-9016-4874-bfe5-b4ddc899a539': {
      name: 'Easy Keto Buddy',
      iconUrl: '',
      endpoint: 'https://chat.dwin.health/easy-keto',
    },
    'cffbc1eb-a963-4e4e-827f-4ecc65922cdb': {
      name: 'Adon Buddy',
      iconUrl: '',
      endpoint: 'https://chat.dwin.health/adon',
    },
    '88799dfc-face-44c3-b194-38168d74153f': {
      name: 'Buddy zu Gesundheitswissen',
      iconUrl: '',
      endpoint: 'https://chat.dwin.health/med-basis',
    },
    '4abbc09c-b5ed-4877-b279-4301fd2511f4': {
      name: 'Buddy Genehmigungsmanager',
      iconUrl: 'https://genehmigungsmanager.de/wp-content/uploads/2022/09/genehmigungsmanager-logo-white.svg',
      endpoint: 'https://chat.dwin.health/genehmigungsmanager',
    },
    '95ed5414-977e-4383-b20a-568ba19172f9': {
      name: 'Buddy',
      iconUrl: 'https://nursit.de/hubfs/Online/Web/Web%20Logo/230707-nursIT-Logo-P-4160-rgb.svg',
      endpoint: 'https://chat.dwin.health/nursit',
    },
  };
}
